import React, { Component } from "react"

import api from "../api.js"

import Screen from "../ui/Screen"

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import ControlPanel from "./PurchaseScreen/ControlPanel"
import PurchaseList from "./PurchaseScreen/PurchaseList"
import CreatePurchaseDialog from "./PurchaseScreen/CreatePurchaseDialog.js"
import DeletePurchaseDialog from "./PurchaseScreen/DeletePurchaseDialog.js"
import EditPurchaseDialog from "./PurchaseScreen/EditPurchaseDialog.js"
import EditPurchaseScreen from "./PurchaseScreen/EditPurchaseScreen.js"

import PaperBlock from "./../ui/PaperBlock.js"

class PurchaseScreen extends Component {

	constructor(props) {
		super(props)
		
		this.state = {
			dialog: undefined,
			screen: undefined,
			selected: undefined,
			purchases: [],
			orderByDate: "DESC",
		}

		this.handle_error = this.handle_error.bind(this)
		this.handle_onCreatePurchaseClick = this.handle_onCreatePurchaseClick.bind(this)
		this.handle_onOpenPurchaseClick = this.handle_onOpenPurchaseClick.bind(this)
		this.handle_onEditPurchaseClick = this.handle_onEditPurchaseClick.bind(this)
		this.handle_onDeletePurchaseClick = this.handle_onDeletePurchaseClick.bind(this)
		this.handle_onPurchaseClick = this.handle_onPurchaseClick.bind(this)
		this.handle_onPurchaseStatusClick = this.handle_onPurchaseStatusClick.bind(this)
		this.handle_onOrderByDateClick = this.handle_onOrderByDateClick.bind(this)

		this.update = this.update.bind(this)
	}

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}

	update = async () => {
		const response = await api.purchases.list(this.state.orderByDate)
		this.setState({purchases: response.purchases})
	}
	
	componentDidMount() {
		this.update().catch(this.handleError)
	}

	handle_onCreatePurchaseClick() {
		this.setState({dialog: <CreatePurchaseDialog 
			onCreatePurchaseClick = {purchase => {
				api.purchases.create(purchase.name)
					.then(response => api.purchases.get(response.id))
					.then(async response => {
						let purchase = response.purchase
						this.setState({
							dialog: undefined,
							screen: <EditPurchaseScreen 
								purchase = {purchase}
								checkboxes = {true}
								onCloseClick = {() => {
									this.update()
										.then(() => this.setState({screen: undefined}))
										.catch(error => this.setState({screen:undefined}, () => this.handle_error(error)))
								}}
							/>
						})
					})
					.catch(this.handle_error)
			}}
			onCancelClick = {() => this.setState({dialog: undefined})}
		/>})
	}

	handle_onEditPurchaseClick(purchase) {
		this.setState({dialog: <EditPurchaseDialog 
			purchase = {purchase}
			onSaveClick = {purchase_edited => api.purchases.update(purchase_edited.id, purchase_edited.name, purchase_edited.status)
				.then(this.update)
				.then(this.setState({dialog: undefined, selected: this.state.purchases.find(p => p.id == purchase_edited.id)}))
				.catch(this.handle_error)
			}
			onCancelClick = {() => this.setState({dialog: undefined})}
		/>})
	}

	handle_onDeletePurchaseClick(purchase) {
		this.setState({dialog: <DeletePurchaseDialog 
			selected = {purchase}
			onDeletePurchaseClick = {purchase => {
				api.purchases.delete(purchase.id)
					.then(this.update)
					.then(() => this.setState({dialog: undefined, selected: undefined}))
					.catch(this.handle_error)
			}}
			onCancelClick = {() => {
				this.setState({dialog: undefined})
			}}
		/>})
	}

	handle_onPurchaseClick(purchase) {
		this.setState({selected: purchase})
	}

	handle_onOpenPurchaseClick(purchase) {

        /**
         * Обновление вложений.
		 * 
		 * Правила:
		 * - Если id не является числом, это новое вложение, так как помечено new_{n}
		 * - Если вложения было в оригинальной версии но пропало в отредактированной, то это вложение должно быть удалено.
		 * - Все остальные вложения подлежат обновлению.
         * 
         * @param {*} purchase_edited - исправленный шаблон
         * @param {*} purchase - оригинальный шаблон (для поиска изменений).
         */		

        const update_attachments = async (purchase_edited, purchase) => {
            let purchase_id = purchase.id
            // Если новое вложение (id помечен как new{n}) то создаем его
            for (let attachment of purchase_edited.attachments) {
                if (isNaN(Number(attachment.id))) {
                    await api.purchases.attachments.create(purchase_id, attachment.item_id, attachment.quantity, attachment.shop_id)
                } 
            }
            // Если вложение пропало, значит его надо удалить, иначе обновить.
            for (let attachment of purchase.attachments) {
                const a = purchase_edited.attachments.find(a => a.id === attachment.id)
                if (a) {
                    await api.purchases.attachments.update(a.id, a.quantity, a.shop_id, a.checked)
                } else {
                    await api.purchases.attachments.delete(attachment.id)
                }
            }
        }

		this.setState({
			dialog: undefined,
			screen: <EditPurchaseScreen 
				purchase = {purchase}
				checkboxes = {true}
				onCloseClick = {() => {
					this.setState({screen: undefined})
					api.purchases.get(purchase.id)
						.then(response => this.setState({purchases: this.state.purchases.map(p => p.id == response.purchase.id ? response.purchase : p)}))
						.catch(this.handle_error)
				}}
			/>
		})
	}

	handle_onPurchaseStatusClick(purchase) {
		let status = purchase.status < 2 ? purchase.status + 1 : 2
		api.purchases.update_status(purchase.id, status)
			.then(this.update)
			.then(() => this.setState({selected: this.state.purchases.find(p => p.id === purchase.id)}))
			.catch(this.handle_error)
	}

	handle_onOrderByDateClick() {
		let orderByDate = this.state.orderByDate === "ASC" ? "DESC" : "ASC"
		this.setState({orderByDate}, this.update)
	}

	render() {

		if (this.state.screen) {
			return this.state.screen
		}

		return <Screen
			onClick = {e => {
				e.stopPropagation()
				if (!this.state.dialog) {
					this.setState({selected: undefined})
				}
			}}
		>

			{this.state.dialog}

			<ControlPanel
				selected = {this.state.selected}
				orderByDate = {this.state.orderByDate}
				onCreatePurchaseClick = {this.handle_onCreatePurchaseClick}
				onOpenPurchaseClick = {this.handle_onOpenPurchaseClick}
				onEditPurchaseClick = {this.handle_onEditPurchaseClick}
				onDeletePurchaseClick = {this.handle_onDeletePurchaseClick}
				onOrderByDateClick = {this.handle_onOrderByDateClick}
			/>

			<PaperBlock style={{width: this.props.width_auto ? "auto" : "100%"}}>
				<PurchaseList
					selected = {this.state.selected}
					purchases = {this.state.purchases}
					onPurchaseClick = {this.handle_onPurchaseClick}
					onPurchaseDoubleClick = {this.handle_onOpenPurchaseClick}
					onPurchaseStatusClick = {this.handle_onPurchaseStatusClick}
				/>
			</PaperBlock>

		</Screen>

	}    

}

export default PurchaseScreen